module.exports = __webpack_public_path__ + "static/img/scorch.0c814e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/scorch.png
// module id = y3Gh
// module chunks = 0